import { render, staticRenderFns } from "./ColoreDialog.vue?vue&type=template&id=4b798996&scoped=true"
import script from "./ColoreDialog.vue?vue&type=script&lang=js"
export * from "./ColoreDialog.vue?vue&type=script&lang=js"
import style0 from "./ColoreDialog.vue?vue&type=style&index=0&id=4b798996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b798996",
  null
  
)

export default component.exports